<template>
  <div class="row-content">
    <div class="flex-box" style="width: 100%; height: 100%">
      <div class="flex-item left">
        <div class="row-title">
          <span>精英机构场地分布</span>
        </div>
        <div class="data-wrapper">
          <div class="echart-associate-all" id="echart-associate-all"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { debounce } from "@/assets/js/utils";

export default {
  props: {
    playerNum: {
      type: Array,
      required: true,
    },
    playerNumZhong: {
      type: Array,
      required: true,
    },
    playerNumGao: {
      type: Array,
      required: true,
    },
    playerKey: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
    };
  },
  computed: {
    lineOptions() {
      const options = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          textStyle: {
            color: '#61a8ff' // 这里设置图例的字体颜色为红色
          },

        },
        grid: {
          left: "3%",
          right: "3%",
          button:"3%"
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            inside: 0, // 横轴图例文字位置（true在bar上）
            rotate: 35,
            textStyle: {
              color: "#61a8ff",
            },
          },
          data: this.playerKey
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: "#61a8ff",
              width: 1,
              type: "solid",
            },
          },
        },
        series: [
          {
            name: '十一人制',
            type: 'bar',

            barwidth: "30%",
            barGap: '20%',
            barCategoryGap: '40%',
            color:'#68D8FE',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: this.playerNum
          },
          {
            name: '八人制',
            type: 'bar',

            barwidth: "30%",
            barGap: '20%',
            barCategoryGap: '40%',
            color:'#FAC858',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: this.playerNumZhong
          },
          {
            name: '五人制',
            type: 'bar',

            barwidth: "30%",
            barGap: '20%',
            barCategoryGap: '40%',
            color:'#EE6666',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: this.playerNumGao
          }
        ]
      };
      return options;
    },
    // 查询总数
    allNumber() {
//      let allCounts = 0;
//      for (let key in this.playerNum) {
//        allCounts += this.playerNum[key]
//      }
//      return allCounts
    },
  },

  mounted() {
    const that = this;
    this.drawLine();
    if (this.lineObj) {
      window.onresize = debounce(
        function () {
          that.lineObj.resize();
        },
        100,
        false
      );
    }
  },

  methods: {
    drawLine() {
      const dom = document.getElementById("echart-associate-all");
      const lineObj = echarts.init(dom);
      this.lineObj = lineObj;
      lineObj && lineObj.setOption(this.lineOptions);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.row-content
  height 320px
  padding 1.25rem 0
  .flex-box
    display flex
    width 100%
    height 100%
    .flex-item
      /* flex 1 1 */
      height 100%
      position: relative;
      .data-wrapper
        height 100%
      .child
        position: absolute; /* 设置为 absolute 进行绝对定位 */
        top: 30px;
        left: 550px;
    .left
      flex 5
    .right
      flex 2
      padding 8rem 2rem 8rem 2rem
      display flex
      flex-direction column
      justify-content space-around
      font-size 1.4rem
      color #61a8ff
      text-align center
      .line-text
        /* text-align left */
        display flex
        justify-content space-between
        span:nth-child(1)
          display flex
          align-items center
          justify-content flex-start
        span:nth-child(2)
          font-size 2.5rem
          margin-left 5px
          color #FFFFFF
          text-align left
          display block
          width 6rem
  .echart-associate-all
    width 100%
    height 100%

.row-content
  .row-title
    color #68d8fe
    font-weight 600
    font-size 16px
    margin-bottom 0.4rem
    display flex
    align-items center
  .data-wrapper
    display flex
    flex-wrap wrap
    .echart-tutorial-add
      height 320px
      width 100%
</style>
